/* eslint-disable no-underscore-dangle */
const samples: Record<string, { name: string; code: string; description?: string; environments: string[] }[]> = {
  Disabled: [],
  Negative: [],
  Informational: [],
  Positive: [],
  NewTableBenchmark: [],
  NewTableScroll: [],
  Ornament: [],
  FormComponents: [],
  Dataviz: [],
};

declare const __INK_SNIPPETS__: {
  name: string;
  description?: string;
  code: string;
  environments: string[];
  group: string;
}[];

__INK_SNIPPETS__
  .filter(sample => sample.environments.includes('expose'))
  .forEach(sample => {
    if (!samples[sample.group]) {
      samples[sample.group] = [
        { name: sample.name, description: sample.description, code: sample.code, environments: sample.environments },
      ];
    } else {
      samples[sample.group].push({
        name: sample.name,
        description: sample.description,
        code: sample.code,
        environments: sample.environments,
      });
    }
  });

export default samples;
